import { useAuth } from '../auth/AuthContext.js'
import { NavIcon } from '../components/NavIcon.js'
import { useNav } from '../nav/NavContext.js'
import { MODULES } from '../nav/modules.js'

/** Landing page after login (Trustline standard, same pattern as TRecon): one card per module. */
export function HomePage() {
  const { go } = useNav()
  const { can } = useAuth()
  const cards = MODULES.filter((m) => !m.permission || can(m.permission))
  return (
    <div className="tf-home-grid">
      {cards.map((m) => (
        <button key={m.key} type="button" className="tf-home-card" onClick={() => go(m.key)}>
          <span className="tf-home-icon">
            <NavIcon name={m.key} size={26} />
          </span>
          <strong>{m.label}</strong>
          <span>{m.desc}</span>
        </button>
      ))}
    </div>
  )
}
